import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { GameStep } from "../../types/config";
import { banimodeUserProd } from "../../utils/endPoints";
import HomePage from "../home/HomePage";
// import { getUser } from "../../store/login/action";
import { configAction } from "../../store/config/slice";
import { getQueryParamFromUrl } from "../../helpers/url";
import Message from "../../components/message/Message";
import { checkingVpn } from "../../store/info/action";
import Wrapper from "./Wrapper";
import { LoadingPage } from "../../components/loading/Loading";
import { scrollToSection } from "../../helpers/scroll";
import { loginAction } from "../../store/login/slice";
import { checkTaraWallet } from "../../store/wallet/action";
const PageLayout = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const { gameSteps } = useAppSelector((state) => state.config);
  const { vpn } = useAppSelector((state) => state.info);

  useEffect(() => {
    // handle login in react native app
    let token, inviteId: any;
    if ((window as any).ReactNativeWebView) {
      // ensure window.ReactNativeWebView is there, otherwise, web app might crash if is not there
      (window as any).ReactNativeWebView.postMessage("SEND_TOKEN");
    }
    document.addEventListener("reactNative", (event) => {
      const message = (event as any).data;
      let appLoginInfo: string | null = message; // get token from react native app
      token = appLoginInfo ? appLoginInfo : "";
      if (token) {
        // dispatch(getUser(token)).finally(() => setLoading(false));
        dispatch(configAction.setToken(token));
      } else {
        setLoading(false);
      }
    });
    token =
      banimodeUserProd && banimodeUserProd.type
        ? banimodeUserProd.token
        : false;
    if (token) {
      const objUrlParams = getQueryParamFromUrl();
      for (let key in objUrlParams) {
        if (key === "id") {
          inviteId = objUrlParams[key];
        }
      }
      if (inviteId) {
        // dispatch(getUser(token, inviteId)).finally(() => setLoading(false));
      } else {
        // dispatch(getUser(token)).finally(() => setLoading(false));
      }
      dispatch(configAction.setToken(token));
      dispatch(loginAction.setUserData(banimodeUserProd.user!));
      // dispatch(checkTaraWallet(token));
    } else {
      setLoading(false);
    }
    // vpn check
    dispatch(checkingVpn());
  }, []);
  useEffect(() => {
    scrollToSection(".main-app");
  }, [gameSteps]);
  return (
    <Wrapper>
      {loading && <LoadingPage />}
      {!loading && gameSteps === GameStep.HOME && <HomePage />}
      {!vpn.data?.data.ip.is_iran_ip && (
        <Message
          text="برای تجربه بهتر VPN را خاموش کنید "
          seconds={[5000, 13000, 17000]}
        />
      )}
    </Wrapper>
  );
};

export default PageLayout;
